:host {
  display: block;
  color: var(--ux-input-error-hint-color);
  font-family: var(--ux-font);
  font-size: var(--ux-input-error-hint-font-size);
  font-weight: var(--ux-input-error-hint-font-weight);
  line-height: var(--ux-input-error-hint-line-height);
  margin: var(--ux-input-error-hint-margin);
  text-transform: var(--ux-input-label-text-transform);
}
